import Contact from "./Contact";
import Customer from "./Customer";

export interface IQuoteRequirements {
  quoteNumber: string;
  orderLockSystemId: number;
  salesArea: string;
  submitToSAP: boolean;
  soldTo: Customer | null;
  soldToDisplay: string;
  shipTo: Customer | null;
  shipToDisplay: string;
  shipToAttention: Contact
  soldToContact: Contact;
  soldToReferenceNumber: string;
}

export default class QuoteRequirements implements IQuoteRequirements {
  constructor(
    public quoteNumber: string = '',
    public orderLockSystemId: number = 0,
    public salesArea: string = '',
    public submitToSAP: boolean = false,
    public soldTo: Customer | null = null,
    public soldToDisplay: string = '',
    public shipTo: Customer | null = null,
    public shipToDisplay: string = '',
    public shipToAttention: Contact = new Contact(),
    public soldToContact: Contact = new Contact(),
    public soldToReferenceNumber: string = ''
  ) {}

  /**
   *
   * @param input
   * @returns
   */
  static deserialize(input: Object): QuoteRequirements {
    return input as IQuoteRequirements;
  }
}
